import api from 'services/api';
// import moment from 'moment';
import { GET, perfRoutes } from 'constants/api';

export const getMetrics = (startDate, endDate, category) =>
  api({
    method: GET,
    url: perfRoutes.SUMMARY,
    params: {
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
      category,
    },
  });

export const getDeliveryRate = (startDate, endDate) =>
  api({
    method: GET,
    url: perfRoutes.DELIVERY_RATE,
    params: {
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
    },
  });

export const getSummary = (startDate, endDate, category) =>
  api({
    method: GET,
    url: perfRoutes.SAVED_SUMMARY,
    params: {
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
      category,
    },
  });

export const getServiceMetrics = (templateId, startDate, endDate) =>
  api({
    method: GET,
    url: `${perfRoutes.SERVICES_BY_TEMPLATE}/${templateId}`,
    params: {
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
    },
  });

export const getLinkMetrics = (templateId, startDate, endDate) =>
  api({
    method: GET,
    url: `${perfRoutes.LINKS_BY_TEMPLATE}/${templateId}`,
    params: {
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
    },
  });

export const getRecipientMetrics = email =>
  api({
    method: GET,
    url: `${perfRoutes.RECIPIENT}/${email}`,
  });

export const countUploadedCSV = ({ search, userId }) =>
  api({
    method: GET,
    url: perfRoutes.COUNT_UPLOADED_CSV,
    params: { search, user_id: userId },
  }).then(data => data.count);

export const getUploadedCSV = ({
  search,
  page,
  limit,
  userIds,
  templateIds,
  esps,
} = {}) =>
  api({
    method: GET,
    url: perfRoutes.GET_UPLOADED_CSV,
    params: { page, limit, search, userIds, templateIds, esps },
  });

export const getCSVMetrics = id =>
  api({
    method: GET,
    url: perfRoutes.GET_CSV_METRICS,
    params: { uploaded_csv_id: id },
  });
